import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { ApiResponse } from './apiCustomerInfoTypes'

export const customerInfoApi = createApi({
  reducerPath: 'customerInfoApiV2',
  baseQuery: fetchBaseQuery({
    baseUrl: window.config.API_URL,
    prepareHeaders: headers => {
      const storeId = window.config.STORE_ID?.toString() || '';
      if (storeId) {
        headers.set('X-BSTORE-ID', storeId);
      }

      return headers  
    },
  }),
  endpoints: builder => ({
    getCustomerInformationList: builder.query<ApiResponse, {customerId: number | string, id_page?: number}>({
      query: ({customerId, id_page}) => {
        // Защита от вызова с null/undefined/0 customerId
        if (!customerId || customerId === 'null' || customerId === 'undefined' || customerId === 0) {
          throw new Error('customerId is required for customer informations')
        }

        return `/suppliers/v1/customers/${customerId}/informations?page=${id_page}`
      },
    }),
  }),
})

export const { useGetCustomerInformationListQuery } = customerInfoApi
